export default __webpack_public_path__ + "static/cloudator-responsive-document-toc-e1b6d7627b78342c55b20ff1aa81d963.jpg";